import showNotify from "./Notify";
import { translatorf } from "Languages/Utility/translatorf";

function StatusHandler(response) {
  let err = {
    text: [],
    isFail: false,
  };

  const statusId = response.status;
  const statusCode = response.data.StatusCode;
  const messageCode = response.data.Message;

  switch (statusId) {
    case 200:
    case 201:
    case 202:
    case 203:
    case 204:
    case 205:
    case 206:
      if (statusCode === -2) {
        err.isFail = true;
        messageCode.map(item => {
          if(item.Code !== "LockedOutMin") {
            err.text.push(item.Code);
            showNotify({
              text: translatorf(item.Code),
              customClass: "error"
            });
          }
        })
      }
      if (statusCode === -1) {
        messageCode.map(item => {
            err.text.push(item.Code);
            showNotify({
              text: translatorf(item.Code),
              customClass: "error"
            });
        })
      }
      return err;

    case 400:
    case 401:
    case 402:
    case 403:
    case 404:
    case 405:
    case 406:
    case 407:
    case 408:
    case 409:
      err.isFail = true;
      err.text = "Client error responses";
      showNotify({ text: "Client error responses" , customClass: "error"});
      return err;

    case 500:
    case 501:
    case 502:
    case 503:
    case 504:
    case 505:
    case 506:
    case 507:
    case 508:
    case 509:
    case 510:
    case 511:
      err.isFail = true;
      err.text = "Server error responses";
      showNotify({ text:"Server error responses" , customClass: "error"});
      return err;
    
    case 988:
      err.isFail = true;
      err.text = "The number of requests exceeds the limit";
      return err;

    default:
      err.text = null;
      err.isFail = false;
      return err;
  }
}

export default StatusHandler;